module.exports = __webpack_public_path__ + "img/lacteo.ca93dd54.png";